module.exports = __webpack_public_path__ + "static/media/Logo-govpl-WHITE.83177134.svg";